(function(){
var fl=document.createElement('link');fl.rel='stylesheet';
fl.href='https://fonts.googleapis.com/css2?family=Great+Vibes&family=Dancing+Script:wght@700&family=Fredoka:wght@700&family=Montserrat:wght@600;700&display=swap';
document.head.appendChild(fl);
var CSS='#gyb{margin:16px 0 0}#gyb .cap{margin:0 0 8px;font-weight:600;font-size:16px}'
+'textarea.custom-property__input{min-height:11.5em}.__character-count{background:#fff;padding:0 3px;border-radius:3px}'
+'#gyc{margin:10px 0 6px;max-width:340px}#gyc .lbl{font-weight:600;font-size:17px;margin:0 0 2px}'
+'#gyc .hint{font-size:15px;opacity:.75;margin:0 0 10px}'
+'#gyc .sw{display:flex;flex-wrap:wrap;gap:8px}'
+'#gyc button{display:flex;align-items:center;gap:7px;font-size:15px;padding:8px 11px;border:1px solid #d8cfc2;background:#fff;border-radius:8px;cursor:pointer;line-height:1}'
+'#gyc button[aria-pressed="true"]{border-color:#333;box-shadow:0 0 0 1px #333}'
+'#gyc i{width:18px;height:18px;border-radius:50%;display:block;border:1px solid rgba(0,0,0,.15)}'
+'#gyb .frame{max-width:340px;padding:10px;background:#fff;border:1px solid #e6ded2;border-radius:10px;box-shadow:0 6px 22px rgba(0,0,0,.10)}'
+'#gyb .art{position:relative;width:100%;overflow:hidden;border-radius:4px;background-size:100% 100%;background-repeat:no-repeat}'
+'#gyb .note{margin:10px 0 0;font-size:14px;opacity:.75;max-width:340px}'
+'#gyb .bx{position:absolute;display:flex;align-items:center;justify-content:center;text-align:center;overflow:hidden}'
+'#gyb .tile{line-height:1;letter-spacing:.22em;text-transform:uppercase;font-weight:600;font-family:Montserrat,sans-serif;align-items:flex-start}'
+'#gyb .tile i{font-style:normal;display:block;white-space:nowrap}'
+'#gyb .list{color:#fff;opacity:.22;letter-spacing:.06em;text-transform:uppercase;font-weight:600;font-family:Montserrat,sans-serif;line-height:1.35;white-space:nowrap;flex-direction:column}'
+'#gyb .cloud{align-items:stretch;flex-direction:column;justify-content:space-between}'
+'#gyb .cloud u{text-decoration:none;display:block;text-align:center;line-height:1.6}'
+'#gyb .cloud span{display:inline-block;font-family:Montserrat,sans-serif;font-weight:700;text-transform:uppercase;margin:0 .3em;vertical-align:middle}'
+'#gyb .meas{position:absolute;visibility:hidden;white-space:nowrap;left:-9999px;top:0}';
var st=document.createElement('style');st.textContent=CSS;document.head.appendChild(st);

var CDN='https://cdn.shopify.com/s/files/1/0770/8167/3883/files/';
var SPEC={
 '1e':{L1:{'3x4':[6.7,35.8,86.7,28.3],'5x6':[4.0,36.7,92.0,28.3]},
       L2:{'3x4':[6.7,5.0,86.7,90.0],'5x6':[4.0,3.3,92.0,93.3]},
   colors:[['','Terracotta','#B86C65'],['coral','Coral','#CC665B'],['khaki','Khaki','#998E63'],
           ['lavender','Lavender','#9579AD'],['roseberry','Rose Berry','#945067'],['skyblue','Sky Blue','#6E99B8']]},
 '1a':{L1:{'3x4':[7.8,58.7,84.4,11.0],'5x6':[8.0,56.7,84.0,13.0]},
       L2:{'3x4':[6.7,5.0,86.7,90.0],'5x6':[4.0,3.3,92.0,93.3]},
   colors:[['','Ocean Blue','#3B7CA6'],['coral','Coral','#CC675B'],['khaki','Khaki','#998D63'],
           ['lavender','Lavender','#9579AC'],['roseberry','Rose Berry','#925167'],['skyblue','Sky Blue','#6E9AB7']]},
 '1b':{L1:{'3x4':[12.2,39.2,75.6,21.7],'5x6':[12.0,38.0,76.0,21.7]},
       L2:{'3x4':[6.7,5.0,86.7,90.0],'5x6':[4.0,3.3,92.0,93.3]},
   colors:[['','Midnight Navy','#101F3C'],['aqua','Forest Green','#1E3D38'],['coral','Oxblood','#3C1B16'],
           ['khaki','Olive','#3C3620'],['lavender','Plum','#2F213B'],['roseberry','Wine','#3C1B26'],
           ['taupe','Espresso','#3B302A']]}
};
var TILE={'1e':'rgba(255,255,255,.30)','1a':'rgba(255,255,255,.17)','1b':'rgba(255,255,255,.17)'};
var PAL=['#F5A9BC','#F3D48C','#9FD9C4','#F2AE86','#C9B4E4','#8FC7E8'];
var SAMPLE=['Emma','Noah','Olivia','Liam','Ava','Ethan','Sophia','Mason'];
var SZ={'30x40':'3x4','50x60':'5x6','60x80':'3x4'};
var BASE={'3x4':4500,'5x6':5000};
var AR={'3x4':0.75,'5x6':5000/6000};

function esc(x){return String(x||'').replace(/&/g,'&amp;').replace(/</g,'&lt;');}
function prop(n){return document.querySelector('[name="properties['+n+']"]');}
function concept(){var h=document.querySelector('h1');var t=(h?h.textContent:'').toLowerCase();
 if(t.indexOf('heart')!==-1)return '1a'; if(t.indexOf('cloud')!==-1)return '1b'; return '1e';}
function sizeKey(){var el=document.querySelector('.variant-option__button-label input:checked');
 var v=el?(el.value||''):''; v=v.replace(/[^0-9x]/gi,'').toLowerCase(); return SZ[v]||'3x4';}

var host,art,meas,colourKey='',colourField,ck=concept();

function bgUrl(sk){return CDN+'blanket-bg-'+ck+(colourKey?'-'+colourKey:'')+'-'+sk+'.jpg';}
function names(){
 var d=prop('Grandchildren names');var raw=(d&&d.value.trim())||'';
 var a=raw?raw.split(/[\r\n,]+/):SAMPLE;
 a=a.map(function(x){return x.trim();}).filter(function(x){return x.length;}).slice(0,30);
 return a.length?a:SAMPLE;
}
function gname(){var f=prop('What she is called');return (f&&f.value.trim())||'Grandma';}
function gyear(){var y=prop('Est year');return (y&&y.value.trim())||'';}
function typed(){var f=prop('What she is called'),d=prop('Grandchildren names');
 return !!((f&&f.value.trim())||(d&&d.value.trim()));}
function wpx(t,ls,w,fam){meas.style.letterSpacing=(ls||0)+'em';meas.style.fontWeight=w||'600';
 meas.style.fontFamily=fam||'Montserrat, sans-serif';meas.style.fontSize='100px';meas.textContent=t;
 return (meas.getBoundingClientRect().width||1)/100;}
function box(c,layer,sk){var b=SPEC[c][layer][sk];
 return 'left:'+b[0]+'%;top:'+b[1]+'%;width:'+b[2]+'%;height:'+b[3]+'%';}
function bh(c,layer,sk,H){return SPEC[c][layer][sk][3]/100*H;}
function bw(c,layer,sk,W){return SPEC[c][layer][sk][2]/100*W;}

function buildColour(){
 if(document.getElementById('gyc'))return;
 var anchor=prop('What she is called'); if(!anchor||!host)return;
 var list=SPEC[ck].colors;
 var wrap=document.createElement('div'); wrap.id='gyc';
 wrap.innerHTML='<p class="lbl">Blanket colour</p><p class="hint">Same design, same price. The picture above updates as you pick.</p>'
  +'<div class="sw">'+list.map(function(c,i){
     return '<button type="button" data-k="'+c[0]+'" data-n="'+esc(c[1])+'" aria-pressed="'+(i===0)+'"><i style="background:'+c[2]+'"></i>'+esc(c[1])+'</button>';
   }).join('')+'</div>';
 host.parentNode.insertBefore(wrap,host.nextSibling);
 colourField=document.createElement('input');
 colourField.type='hidden'; colourField.name='properties[Colour]'; colourField.value=list[0][1];
 var fid=anchor.getAttribute('form'); if(fid)colourField.setAttribute('form',fid);
 wrap.appendChild(colourField);
 wrap.addEventListener('click',function(e){
   var b=e.target.closest('button[data-k]'); if(!b)return;
   [].forEach.call(wrap.querySelectorAll('button[data-k]'),function(x){x.setAttribute('aria-pressed','false');});
   b.setAttribute('aria-pressed','true');
   colourKey=b.getAttribute('data-k');
   colourField.value=b.getAttribute('data-n');
   render();
 });
}

function render(){
 if(!art)return;
 var sk=sizeKey();
 art.style.aspectRatio=String(AR[sk]);
 art.style.backgroundImage='url('+bgUrl(sk)+')';
 var W=art.clientWidth||320, H=W/AR[sk];
 var k=W/BASE[sk];
 var ns=names(), gn=gname(), yr=gyear();
 var html='<span class="meas"></span>', L2='', L1='';

 if(ck==='1e'){
   var bW=bw(ck,'L2',sk,W), bH=bh(ck,'L2',sk,H);
   var longest=ns.reduce(function(a,b){return b.length>a.length?b:a;},'');
   var fs=Math.min(bW/wpx(longest.toUpperCase(),0.06,'600'), bH/(ns.length*1.35), 560*k);
   fs=Math.max(240*k*0.35,fs);
   L2='<div class="bx list" style="'+box(ck,'L2',sk)+';font-size:'+fs.toFixed(2)+'px">'
     +ns.map(function(n){return '<span>'+esc(n)+'</span>';}).join('')+'</div>';
   var cap=(sk==='3x4')?1500:2520, num=(sk==='3x4')?3900:6900;
   var f1=Math.min(cap, num/Math.max(1,gn.length)/0.42)*k;
   f1=Math.min(f1, bh(ck,'L1',sk,H)*0.95);
   L1='<div class="bx" style="'+box(ck,'L1',sk)+';font-family:\'Great Vibes\',cursive;color:#fff;'
     +'font-size:'+f1.toFixed(2)+'px;line-height:1">'+esc(gn.toLowerCase())+'</div>';
 }
 else if(ck==='1a'){
   var tf=110*k, lh=240*k, bH2=bh(ck,'L2',sk,H);
   var unit=ns.map(function(n){return esc(n.toUpperCase());}).join(' &#9829; ');
   var rows=Math.ceil(bH2/lh)+1, out=[];
   for(var r=0;r<rows;r++){out.push('<i>'+unit+' &#9829; '+unit+'</i>');}
   L2='<div class="bx tile" style="'+box(ck,'L2',sk)+';color:'+TILE[ck]+';font-size:'+tf.toFixed(2)+'px;line-height:'+lh.toFixed(2)+'px;flex-direction:column">'+out.join('')+'</div>';
   var cap1=(sk==='3x4')?780:1440, num1=(sk==='3x4')?3800:6300;
   var fa=Math.min(cap1, num1/Math.max(1,gn.length)/0.70)*k;
   fa=Math.min(fa, bh(ck,'L1',sk,H)*0.92);
   L1='<div class="bx" style="'+box(ck,'L1',sk)+';font-family:Fredoka,Montserrat,sans-serif;font-weight:700;'
     +'color:#fff;font-size:'+fa.toFixed(2)+'px;line-height:1">'+esc(gn.toUpperCase())+'</div>';
 }
 else {
   var pool=ns.slice(); while(pool.length<16){pool=pool.concat(ns);} pool=pool.slice(0,Math.max(16,ns.length));
   var half=Math.ceil(pool.length/2);
   var grp=function(arr,off){return '<u>'+arr.map(function(n,i){var idx=i+off;
     var vert=(idx%7===5); var rot=vert?90:(-8+((idx*37)%16));
     var fs2=(H*0.030)*(1+((idx%3)*0.16));
     return '<span style="color:'+PAL[idx%6]+';font-size:'+fs2.toFixed(2)+'px;transform:rotate('+rot+'deg)'
       +(vert?';margin:0 .9em':'')+'">'+esc(n.toUpperCase())+'</span>';
    }).join('')+'</u>';};
   L2='<div class="bx cloud" style="'+box(ck,'L2',sk)+'">'+grp(pool.slice(0,half),0)+grp(pool.slice(half),half)+'</div>';
   var fb=Math.min(bw(ck,'L1',sk,W)/wpx(gn,0,'700','\'Dancing Script\', cursive'), bh(ck,'L1',sk,H)*0.60);
   var fe=Math.max(6,bh(ck,'L1',sk,H)*0.16);
   L1='<div class="bx" style="'+box(ck,'L1',sk)+';flex-direction:column"><span style="font-family:\'Dancing Script\',cursive;'
     +'font-weight:700;color:#F7E9C6;font-size:'+fb.toFixed(2)+'px;line-height:1.05">'+esc(gn)+'</span>'
     +(yr?'<span style="font-family:Montserrat,sans-serif;font-weight:600;color:#F5A9BC;letter-spacing:.34em;'
        +'font-size:'+fe.toFixed(2)+'px;margin-top:.45em">EST. '+esc(yr)+'</span>':'')+'</div>';
 }
 art.innerHTML=html+L2+L1;
 meas=art.querySelector('.meas');
 art.style.opacity=typed()?'1':'0.82';
}

function bind(){
 host=document.getElementById('gyb');
 var f=prop('What she is called'),d=prop('Grandchildren names');
 if(!host||!f||!d){return setTimeout(bind,600);}
 host.innerHTML='<p class="cap">Your blanket, as you type</p><div class="frame"><div class="art"><span class="meas"></span></div></div>'
  +'<p class="note">This is your actual design, in the colour you picked, with your names in place &mdash; exactly what we print. Please check every spelling before you order.</p>';
 art=host.querySelector('.art');meas=host.querySelector('.meas');
 buildColour();
 [f,d,prop('Est year')].forEach(function(el){if(el)el.addEventListener('input',render);});
 var vs=document.querySelectorAll('.variant-option__button-label input');
 for(var i=0;i<vs.length;i++){vs[i].addEventListener('change',function(){setTimeout(render,60);});}
 window.addEventListener('resize',render);
 if(document.fonts&&document.fonts.ready){document.fonts.ready.then(render);}
 render();setTimeout(render,900);setTimeout(render,2200);
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',bind);}else{bind();}
})();
